import { Component, computed, input, Signal, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';
import {
    ShDatepickerComponent,
    ShDatepickerRangeFormBridgeDirective,
    ShDatepickerValueAccessorDirective
} from '@gbr-monorepo/gbr-shui';
import { LanguageCode } from '@gbr-monorepo/interfaces';
import { TranslateModule } from '@ngx-translate/core';
import { select } from '@ngxs/store';
import { UserState } from '../../../../auth/state/user.state';
import { SeasonFormGroup, SeasonTimeframeFormGroup } from '../../../models/season-form.model';
import { SeasonBaseFormHeaderComponent } from '../season-base-form/season-base-form-header/season-base-form-header.component';
import { SeasonBaseFormComponent } from '../season-base-form/season-base-form.component';

@Component({
    selector: 'app-timeframe',
    templateUrl: './timeframe.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ReactiveFormsModule,
        TranslateModule,
        SeasonBaseFormHeaderComponent,
        ShDatepickerComponent,
        ShDatepickerValueAccessorDirective,
        ShDatepickerRangeFormBridgeDirective
    ]
})
export class TimeframeComponent extends SeasonBaseFormComponent {
    public readonly timeframe = input.required<SeasonFormGroup['timeframe']>();
    protected readonly userLanguage: Signal<LanguageCode> = select(UserState.userLanguage);
    protected readonly datepickerLocale = computed(() => this.userLanguage());

    protected getFormControl(): AbstractControl {
        return this.timeframe();
    }

    protected isInvalid(controlName: keyof SeasonTimeframeFormGroup): boolean {
        const control = this.timeframe().get(controlName);
        return !!(control?.invalid && (control?.touched || control?.dirty));
    }

    protected errorMessage(control: string): string {
        const controlErrors = this.timeframe().get(control)?.errors || {};
        const errorKeys = Object.keys(controlErrors);

        if (errorKeys.length) {
            if (errorKeys[0] === 'required' && !this.timeframe().get(control)?.touched) {
                return '';
            }

            return `seasons.season-creation.errors.${errorKeys[0]}`;
        }

        return '';
    }

    protected groupErrorMessage(errorKey: string): string {
        return this.hasGroupError(errorKey) ? `seasons.season-creation.errors.${errorKey}` : '';
    }

    protected hasGroupError(errorKey: string): boolean {
        return this.timeframe().hasError(errorKey);
    }
}
